import React, { Fragment, useEffect, useState } from 'react';
import Trial from '../Home/Trial';
import Banner from '../Organization/Banner';
import FeaturesOrganization from './FeaturesOrganization';
import Footer from '../Footer/Footer';
import Loader from '../../loader/Loader';
import Benefits from '../Home/Benefits';
import PageSEO from '../Common/PageSEO';
import { useLocale } from '../../localization/LocaleContext';

function OrganizationMain(){
    const { t, locale } = useLocale();

   const[loader, SetLoader] = useState(false)

    useEffect(() => {
        const timer = setTimeout(() => {
            SetLoader(true)
        }, 1500)

        return () => clearTimeout(timer)
    }, [])

    if (!loader) {
        return <Loader/>;
    }
    return(
        <Fragment>
                <PageSEO title={t('meta.organizationTitle')} description={t('meta.organizationDescription')} path="/organization" locale={locale} />
                <Banner />
                <FeaturesOrganization/>
                <Benefits />
                <Trial/>
                <Footer />
        </Fragment>
    )
}

export default OrganizationMain;